import { FaStar } from "react-icons/fa";
import styled from "styled-components";

export const Styled = {
    Wrapper: styled.div`
        /* border: 1px solid #f00; */
        margin-top: 30px;
    `,
};

export const Header = styled.div`
    /* border: 1px solid #f00; */

    .row1 {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .heading_text {
            letter-spacing: -0.025em;
            line-height: 1;
            font-weight: 700;
            font-size: 1.5rem;
            line-height: 2rem;
            color: var(--primary-text-color);
        }

        .add_video {
            background-color: hsl(265 89% 60% / var(--tw-bg-opacity, 1));
            color: #fff;

            &:hover {
                background-color: hsl(265 89% 60% / 0.9);
            }
        }
    }

    .row2 {
        color: var(--secondary-text-color);
        font-size: 0.875rem;
        line-height: 1.25rem;
    }
`;

export const ControlsSection = styled.div`
    /* border: 1px solid #f00; */
    margin-top: 15px;
    display: flex;
    align-items: stretch;
    gap: 15px;

    .search_wrapper {
        width: 100%;
        position: relative;
        border: 1px solid var(--border-color);
        border-radius: 5px;
        overflow: hidden;
        display: flex;
        align-items: center;

        .icon_wrapper {
            /* border: 1px solid #f00; */
            width: 30px;
            display: flex;
            justify-content: center;
            align-items: center;
            color: var(--secondary-text-color);
        }

        input {
            width: 100%;
            border: none;
            outline: none;
            padding: 5px;
            background-color: inherit;
        }
    }

    .filter {
        /* width: 100px; */
        border: 1px solid var(--border-color);
        padding: 0 15px;
        display: flex;
        align-items: center;
        gap: 10px;
        border-radius: 5px;
        cursor: pointer;
        color: var(--secondary-text-color);
    }

    .export {
        border: 1px solid var(--border-color);
        padding: 0 15px;
        display: flex;
        align-items: center;
        gap: 10px;
        border-radius: 5px;
        cursor: pointer;
        color: var(--secondary-text-color);
    }
`;

export const PatientEngagementByGroup = styled.div`
    margin-top: 30px;

    .header {
        font-weight: 600;
    }

    table {
        border: 1px solid var(--border-color);
        border-radius: 8px;

        width: 100%;
        border-collapse: collapse;

        thead {
            /* background-color: #f9fafb; */
            color: var(--secondary-text-color);
        }

        th,
        td {
            text-align: left;
            padding: 12px;
            font-size: 0.95rem;
            border-bottom: 1px solid var(--border-color);
        }

        th {
            font-weight: 500;
        }

        td {
            color: var(--primary-text-color);

            &:nth-last-child(1) {
                padding-left: 30px;
            }
        }

        .trend {
            color: #10b981; /* green-500 */
            font-weight: 500;
        }
    }
`;

export const Star = styled(FaStar)`
    color: #facc15;
    margin-right: 4px;
`;

export const CTAButton = styled.button`
    border: none;
    display: flex;

    --tw-ring-offset-color: hsl(var(--background));
    --tw-text-opacity: 1;
    color: hsl(0 0% 100% / var(--tw-text-opacity, 1));
    font-weight: 500;
    font-size: 0.875rem;
    line-height: 1.25rem;
    padding-left: 0.75rem;
    padding-right: 0.75rem;
    --tw-bg-opacity: 1;
    background-color: hsl(265 89% 60% / var(--tw-bg-opacity, 1));
    border-radius: calc(var(--radius) - 2px);
    border-radius: 6px;
    white-space: nowrap;
    gap: 0.5rem;
    justify-content: center;
    align-items: center;
    height: 2.25rem;
    display: inline-flex;
    cursor: pointer;

    &:hover {
        background-color: hsl(265 89% 60% / 0.9);
    }
`;
